    <div class="connection-list-container mb-3 rounded-corners-12">
        <div class="list-connection" 
            infiniteScroll 
            [infiniteScrollDistance]="numbers.ONE" 
            [infiniteScrollThrottle]="numbers.ONE_THOUSAND"
            (scrolled)="onScroll()" 
            [scrollWindow]="true">
            <div class="p-3 my-3 bg-white container-shadow" 
                *ngFor="let reqObj of joiningRequestsData; let index=index">
                <div class="row">
                    <div class="col-12 d-none d-md-block">
                        <div class="row">
                            <div class="col-6" (click)="fcs.navigateToUserProfie(reqObj?.custom_id)">
                                <div class="float-left mr-2 connection-profile-container box-height-40 cursor-pointer">
                                    <div class="position-relative">
                                        <!-- image -->
                                        <img class="rounded-circle"
                                            [src]="reqObj?.profile_pic | fitInImg :igs.imageGroup.fitin_110x110"
                                            onError="this.src='assets/themes/icons/user-profile-placeholder.svg';" 
                                            alt="Profile Pic"/>
                                    </div>
                                </div>
                                <div class="float-left pl-0 lh-1 table-row-parent-info cursor-pointer">
                                    <div class="d-table w-100 table-row-left-panel">
                                        <div class="d-table-cell align-middle">
                                            <div class="ellipsis position-relative">
                                                <p class="text-capitalize paragraph">
                                                    <span class="font-weight-600 ">{{reqObj?.full_name}}</span>
                                                </p>
                                                <p class="secondary-paragraph">
                                                    <span class="color-grey-500">
                                                        {{reqObj?.specialities[0]?.speciality_name}}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 pl-0 d-flex justify-content-end align-items-center">
                                <img 
                                    (click)="ignoreJoinRequest(reqObj)"
                                    src="assets/themes/icons/Reject.svg" 
                                    alt="reject icon"
                                    class="cursor-pointer mr-2"/>
                                <img 
                                    (click)="acceptJoinRequest(reqObj)" 
                                    src="assets/themes/icons/accept.svg" 
                                    alt="accept icon"
                                    class="cursor-pointer" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 d-block d-md-none">
                        <div class="row">
                            <div class="col-8 col-sm-6">
                                <div class="float-left mr-2 connection-profile box-height-40">
                                    <div class="position-relative">
                                        <!-- image -->
                                        <img class="rounded-circle box-height-40 post-pic"
                                            [src]="reqObj?.profile_pic | fitInImg :igs.imageGroup.fitin_110x110"
                                            onError="this.src='assets/images/grandround/user_placeholder.svg';"
                                            alt="Profile Pic" />
                                    </div>
                                </div>
                                <div class="float-left pl-0 lh-1 table-row-parent-info">
                                    <div class="d-table w-100 table-row-left-panel">
                                        <div class="d-table-cell align-middle">
                                            <div class="ellipsis position-relative">
                                                <p class="text-capitalize secondary-paragraph-bold">
                                                    {{reqObj?.full_name}}
                                                </p>
                                                <p class="primary-small py-2">
                                                    <span class="color-grey-500">
                                                        {{reqObj?.specialities[0]?.speciality_name}}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 col-sm-6 pl-0 d-flex justify-content-end align-items-center">
                                <img 
                                    (click)="ignoreJoinRequest(reqObj)"
                                    src="assets/themes/icons/Reject.svg" 
                                    alt="reject icon"
                                    class="cursor-pointer mr-2"/>
                                <img 
                                    (click)="acceptJoinRequest(reqObj)" 
                                    src="assets/themes/icons/accept.svg" 
                                    alt="accept icon"
                                    class="cursor-pointer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>      
        </div>
        <div class='text-center' *ngIf="!finished && masterService.isOnline">
            <img class="text-center"
                src="assets/themse/images/primary-loader.gif" 
                width="40" 
                height="40" 
                id="loadmore_post" 
                alt="load more">
        </div>
    </div>
    <div class='text-center p-3' *ngIf="joiningRequestsData.length === numbers.ZERO">
        <img class="join-requests-no-data-image" src="assets/images/profile/posting_profile.svg" alt="no data"><br>
        <span><b>{{mls.languageText.community.key62}}</b></span>
    </div>
    <app-confirm-modal 
        *ngIf="isConfirmModalShown" 
        (resetConfirmModal)="resetConfirmModal($event)"
        [isConfirmModalShown]="isConfirmModalShown" 
        [confirmInfo]="confirmInfo" 
        [communityId]="communityDetailId">
    </app-confirm-modal>